<template>
  <div class="house-importer-import-comments" :class="{
    'house-importer-import-comments_open': isActive
  }"
  v-click-outside="() => {isActive = false}">
    <div class="house-importer-import-comments__header" @click="isActive = true">
      <div style="flex: 1;">
        <div class="house-importer-import-comments__heading">КОММЕНТАРИИ</div>
        <div class="house-importer-import-comments__sub-heading">{{getFullAddress(importInfo.address)}}</div>
      </div>

      <div class="house-importer-import-comments__header-icon link-icon" @click.stop="isActive = false">
        <app-icon name="XIcon" size="14px"/>
      </div>
    </div>

    <div class="house-importer-import-comments__content" v-if="isActive">
      <div class="house-importer-import-comments__toolbar">
        <div :id="`toolbar-container-${_uid}`">
          <div>
            <button class="ql-bold" />
            <button class="ql-italic" />
            <button class="ql-underline" />
          </div>

          <div class="house-importer-import-comments__toolbar-button" @click.stop="saveComment">
            <app-icon name="SaveIcon" size="18px" style="stroke: currentColor; stroke-width: 20"/>
          </div>
        </div>
        <div style="text-align: center">
          <span style="font-size: 10px">
            <span style="font-weight: 500;">Ctrl+Enter</span> сохраняет комментарий
          </span>
        </div>
      </div>

      <quill-editor :options="quillEditorOptions"
                    ref="quill"
                    v-model="comment"
                    placeholder="Комментарий пуст"
                    @keydown.ctrl.enter.native.capture.prevent="saveComment"
      />
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import { Quill, quillEditor } from 'vue-quill-editor'

  export default {
    name: "ImportComments",
    components: {quillEditor},
    props: {
      importInfo: {}
    },
    data(){
      return {
        isOpeningFirst: true,
        comment: "",
        isActive: false,
        quillEditorOptions: {
          root: {
            spellcheck: false
          },
          modules: {
            toolbar: `#toolbar-container-${this._uid}`
          },
          grammar: {
            checkSpelling: false,
          },
          spellcheck: false
        },
      }
    },
    methods: {
      getFullAddress(data){
        return Object.values(data).join(', ');
      },
      async saveComment(){
        try{
          let body = {
            import_id: this.importInfo.id,
            comment: this.comment
          };
          await this.$http.post('import/houses/comment', body);
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      }
    },
    mounted() {
      this.comment = this.importInfo.comment || "";
    },
    watch: {
      isActive(){
        if(this.isActive){
          this.$nextTick(() => {
            this.$refs.quill.quill.root.setAttribute('spellcheck', false);
            this.$refs.quill.quill.root.setAttribute('data-placeholder', "Комментарий пуст");

            if(this.isOpeningFirst){
              this.$refs.quill.quill.root.scrollTop = this.$refs.quill.quill.root.scrollHeight;
              this.isOpeningFirst = false;
            }
          });
        }
      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-comments{
    position: fixed;
    left: 5px;
    bottom: 5px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, .2);
    box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .08), 0 1px 4px rgba(0, 0, 0, .1);
    width: 380px;
    z-index: 9999;
    transition: all 0.2s ease 0s;
    height: 65px;

    &__heading{
      color: #00aeef;
      font-weight: 600;
    }

    &__sub-heading{
      font-weight: 500;
    }

    &__header{
      height: 65px;
      cursor: pointer;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-icon{
        display: none;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
    }

    &__content{
      height: calc(100% - 65px);
    }

    &__toolbar{
      border-bottom: 1px solid rgba(0, 0, 0, .2);
      height: 55px;
      padding: 10px;


      &-button{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;

        &:hover{
          cursor: pointer;
          color: rgba(var(--app-success), 1);
        }
      }
    }

    &_open{
      height: 520px;
      .house-importer-import-comments{

        &__header{
          border-bottom: 1px solid rgba(0,0,0,.1);

          &-icon{
            display: flex;
          }
        }

      }
    }
  }

  .ql-toolbar.ql-snow{
    border: none;
    display: flex;
    align-items: center;
    padding: 0;
  }

  .ql-container.ql-snow{
    border: none;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
  }

  .quill-editor{
    height: calc(100% - 55px);
  }

  .ql-editor{
    line-height: 1.1;
    padding: 0 10px;

    p{
      margin: 10px 0px;
    }
  }

  .ql-editor.ql-blank::before{
    top: 10px;
  }
</style>